import { useQuery } from "@tanstack/react-query";
import { FunctionsHttpError } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import { LocalMap } from "@/components/public/LocalMap";

export function CompanyLocationMap({ address, title }: { address: string; title: string }) {
  const location = useQuery({
    queryKey: ["company-map-location", address],
    staleTime: 30 * 60 * 1000,
    retry: false,
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("geocode-address", { body: { address } });
      if (error) {
        const details = error instanceof FunctionsHttpError
          ? await error.context.json().catch(() => null)
          : null;
        throw new Error(details?.error || "No se pudo localizar la dirección de la empresa.");
      }
      if (data?.error) throw new Error(data.error);
      if (!Number.isFinite(data?.latitude) || !Number.isFinite(data?.longitude)) throw new Error("No se encontraron coordenadas para la empresa.");
      return data as { latitude: number; longitude: number };
    },
  });
  if (location.isPending) return <div className="w-full h-full animate-pulse bg-muted" />;
  if (!location.data) return <div role="status" className="h-full flex items-center justify-center p-4 text-center text-sm text-muted-foreground">{location.error?.message}</div>;
  return <LocalMap latitude={location.data.latitude} longitude={location.data.longitude} title={title} className="w-full h-full" />;
}